<df-icon [icon]="icon" [size]="size"></df-icon>
<label [attr.for]="searchId" class="a11y-hide">{{ placeholder }}</label>
<input
  dfInputDebounce
  (inputValueChange)="changeEvent($event)"
  [attr.id]="searchId"
  [attr.name]="searchId"
  type="search"
  autocomplete="off"
  (focus)="onTouched()"
  (blur)="onTouched()"
  [disabled]="disabled"
  [placeholder]="placeholder"
/>
